import { PatientGoal } from "./patient_goal_class";
import { Measurement } from "./measurements/measurement";
import { any } from "prop-types";

export class PatientGoalObservation extends PatientGoal {
  public measurementId: number | null;
  public measurement: any;

  constructor({
    achievementCondition,
    achievementProgress,
    achievementTarget = null,
    achievementTargetFormatted,
    achievementThreshold,
    active,
    continuous,
    createdAt,
    deactivatedAt,
    description,
    endDateFormatted,
    goalTemplate,
    goalTypeSpecifics,
    id = null,
    initialReading = null,
    initialReadingFormatted,
    leaderboardEnabled = false,
    leaderboardIncluded,
    monitorProfileId,
    name,
    occurrenceAmount,
    occurrenceFrequency,
    startDateFormatted,
    type,
    updatedAt,
  }: any) {
    let extendedData = {
      achievementCondition: achievementCondition,
      achievementProgress: achievementProgress,
      achievementTarget: achievementTargetFormatted
        ? achievementTargetFormatted
        : achievementTarget,
      achievementThreshold: achievementThreshold,
      active: active,
      continuous: continuous,
      createdAt: createdAt,
      deactivatedAt: deactivatedAt,
      description: description,
      endDate: endDateFormatted,
      goalTemplateId: goalTemplate.id,
      id: id,
      initialReading: initialReadingFormatted
        ? initialReadingFormatted
        : initialReading,
      leaderboardEnabled: leaderboardEnabled,
      leaderboardIncluded: leaderboardIncluded,
      monitorProfileId: monitorProfileId,
      name: name,
      occurrenceAmount: occurrenceAmount,
      occurrenceFrequency: occurrenceFrequency,
      type: type,
      startDate: startDateFormatted,
      updatedAt: updatedAt,
    };

    super(extendedData);

    this.measurementId = goalTypeSpecifics;
    this.measurement = Measurement.findById(this.measurementId);
  }
}
